import { useState } from "react";
import { flashItems } from "../../../mocks/clueSite";

const tones: Record<string, { chip: string; dot: string }> = {
  primary: { chip: "bg-primary-100 text-primary-700", dot: "bg-primary-500" },
  accent: { chip: "bg-accent-100 text-accent-800", dot: "bg-accent-500" },
  secondary: { chip: "bg-secondary-100 text-secondary-800", dot: "bg-secondary-500" },
};

export default function FlashFeed() {
  const cats = ["全部", "独家", "财经", "职场", "消费", "娱乐", "地产"];
  const [cat, setCat] = useState("全部");
  const [seen, setSeen] = useState<Set<string>>(new Set());

  const list = cat === "全部" ? flashItems : flashItems.filter((f) => f.cat === cat || f.tag === cat);

  const toggleSeen = (id: string) => {
    setSeen((prev) => {
      const n = new Set(prev);
      if (n.has(id)) n.delete(id);
      else n.add(id);
      return n;
    });
  };

  return (
    <section id="feed" className="bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6 py-12 md:py-16">
        <div className="flex items-end justify-between gap-3 flex-wrap">
          <div>
            <div className="flex items-center gap-2">
              <i className="ri-rss-fill text-primary-600 text-xl" />
              <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950">线报速递</h2>
              <span className="relative flex h-2.5 w-2.5">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-75" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-accent-500" />
              </span>
            </div>
            <p className="mt-2 text-sm text-foreground-600">按时间倒序滚动更新，可点标题标记"已读"；下方为实时投稿统计。</p>
          </div>
          <div className="inline-flex items-center gap-1 rounded-full bg-background-100 border border-background-200 p-1 overflow-x-auto max-w-full">
            {cats.map((c) => (
              <button
                key={c}
                onClick={() => setCat(c)}
                className={`rounded-full px-3 py-1.5 text-sm whitespace-nowrap ${
                  cat === c ? "bg-foreground-950 text-background-50" : "text-foreground-600 hover:text-foreground-900"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-7 grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* 短讯列表 */}
          <div className="lg:col-span-2 divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
            {list.map((f) => {
              const t = tones[f.tone];
              return (
                <div
                  key={f.id}
                  className="group flex items-start gap-3 px-3 py-3.5 md:px-4 hover:bg-background-100"
                >
                  <button
                    onClick={() => toggleSeen(f.id)}
                    aria-label="标记已读"
                    className={`mt-1 flex-none flex h-5 w-5 items-center justify-center rounded-full border transition-colors ${
                      seen.has(f.id)
                        ? "border-accent-500 bg-accent-500 text-background-50"
                        : "border-background-300 text-transparent hover:border-accent-500"
                    }`}
                  >
                    <i className="ri-check-line text-xs" />
                  </button>
                  <span
                    className={`mt-0.5 flex-none rounded ${t.chip} px-1.5 py-0.5 text-[11px] font-medium`}
                  >
                    {f.tag}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm md:text-[15px] leading-relaxed text-foreground-800 group-hover:text-primary-800">
                      {f.title}
                    </p>
                    <div className="mt-1 flex items-center gap-2 text-[11px] text-foreground-500">
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line" />
                        {f.time}
                      </span>
                      <span className="flex items-center gap-1">
                        <span className={`inline-block h-1.5 w-1.5 rounded-full ${t.dot}`} />
                        {f.src}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
            {list.length === 0 && (
              <p className="px-4 py-10 text-center text-sm text-foreground-500">该分类暂无新线报，切换到其他分类看看。</p>
            )}
          </div>

          {/* 侧栏统计 + 预约入口 */}
          <aside className="space-y-3">
            <div className="grid grid-cols-2 gap-3">
              {[
                { icon: "ri-file-upload-line", v: "1,204", l: "今日收到投稿", c: "text-primary-600" },
                { icon: "ri-search-line", v: "89", l: "正在核验", c: "text-accent-600" },
                { icon: "ri-check-double-line", v: "62%", l: "累计采纳率", c: "text-foreground-900" },
                { icon: "ri-user-heart-line", v: "4,871", l: "活跃线人", c: "text-secondary-700" },
              ].map((s) => (
                <div key={s.l} className="rounded-md border border-background-200 bg-background-100 p-3.5">
                  <i className={`${s.icon} ${s.c} text-lg`} />
                  <p className="mt-1 font-number text-xl md:text-2xl font-extrabold text-foreground-950">{s.v}</p>
                  <p className="text-xs text-foreground-500">{s.l}</p>
                </div>
              ))}
            </div>
            <div className="rounded-md border border-primary-200 bg-primary-50 p-4">
              <div className="flex items-center gap-2 text-primary-700">
                <i className="ri-alarm-line text-lg" />
                <p className="text-sm font-semibold">今日头条征集令</p>
              </div>
              <p className="mt-2 text-xs leading-relaxed text-foreground-700">
                正面向全网征集"补贴政策外泄"相关一手材料，提供核心证据者优先进入核实快车道。
              </p>
              <a
                href="#guide"
                className="mt-3 inline-flex w-full items-center justify-center gap-1.5 rounded-full bg-primary-600 px-4 py-2 text-sm text-background-50 hover:bg-primary-500 whitespace-nowrap"
              >
                去提供线索
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}